export default __webpack_public_path__ + "static/media/holographic-flat.573f5fca.svg";